export default "__VITE_ASSET__BOY3FIc___"